export default "__VITE_ASSET__CM76O7Xx__"